import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=640f4df4&scoped=true&"
import script from "./MenuBar.vue?vue&type=script&lang=js&"
export * from "./MenuBar.vue?vue&type=script&lang=js&"
import style0 from "./MenuBar.vue?vue&type=style&index=0&id=640f4df4&lang=scss&scoped=true&"
import style1 from "./MenuBar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f4df4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('640f4df4')) {
      api.createRecord('640f4df4', component.options)
    } else {
      api.reload('640f4df4', component.options)
    }
    module.hot.accept("./MenuBar.vue?vue&type=template&id=640f4df4&scoped=true&", function () {
      api.rerender('640f4df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/MenuBar.vue"
export default component.exports